import React from 'react';
import SelectField from 'components/input/SelectField/SelectField';

const BookingFilter = <SelectField
    choices={ [
        {
            id: '1',
            name: 'actions.yes',
        },
        {
            id: '0',
            name: 'actions.no',
        },
    ] }
    floatingLabelFixed={ true }
    fullWidth={ true }
    label='filters.components.booking.label'
    source='is_booking'
/>;

export default BookingFilter;



// WEBPACK FOOTER //
// ./src/components/form/filters/BookingFilter.js